import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import GET_ARTICLES from '../plugins/getArticles'

const [ w, d, l, mq ] = [ window, document, location, window.matchMedia( "(max-width: 900px)" ) ]

const init = () => {
  gsap.registerPlugin( ScrollTrigger )
}

const documentReady = () => {
  
  const parallax = () => {
    let $boxes = $('[data-plugin="parallax"]')
    $boxes.each( (i,obj) => {
      gsap.fromTo( obj, {
        y: '0'
      },{
        y: obj.dataset.duration+"px" || '10vh',
        // yPercent: 100 * parseFloat( obj.dataset.speed || 1 ),
        // xPercent: -100 * parseFloat( obj.dataset.speed || 1 ),
        scrollTrigger: {
          trigger: obj,
          start: `top ${obj.dataset.startAt || 'top'}`, // the default values
          end: `+=${window.innerHeight + ( parseInt(obj.dataset.duration) + parseInt(obj.clientHeight) + parseInt(obj.clientHeight) )}px`,
          scrub: true, // アニメーションをスクロール位置にリンクさせる
          markers: (obj.dataset.marker == 'true'), // マーカー表示
          onEnter: () => false,
          onEnterBack: () => false,
          onLeave: () => false,
          onLeaveBack: () => false
        }
      })
    })
  }

  $.when( w.load['mainvisual'] ).then( () => {
    let makeItem = item => $(`
    <a href="${item.href}" class="link">
    <span class="cate">【${item.category.name}】</span>
    <span class="date">${item.date}</span>
    <span class="subject">${item.title}</span>
    </a>
    `)[0]
    GET_ARTICLES('.ticker-news__article[data-plugin="getArticles"]', { makeItem })
  })

  // shop
  $.when(
    $.ajax({
      url: '/asset/api/getArticles/',
      dataType: 'json',
      data: { content: 'shop' },
      cache: false
    }),
    $.ajax({
      url: '/asset/api/getCategories/',
      dataType: 'json',
      data: {content: 'shop'},
      cache: false
    }),
    w.load['block-shop-head']
  ).then( (data,catdata) => {

    const is_new = (date,d) => ( new Date() - (1000*60*60*24*d) <= date )? true : false

    // 記事データ整形
    catdata = catdata[0]
    data = data[0].map(item => {
      // カテゴリIDをオブジェクトに変換
      item.category = catdata.filter(cat => cat.id == item.category).shift()
      if(!item.category) item.category = {id:'0',name:'その他',href:`/${container.dataset.content}/?mode=list&cat=0`}
      // NEWマーク判定
      item.is_new = is_new(item.date*1000, 7) // 7days
      // 日付表記変換
      const d = new Date(item.date*1000)
      item.date = w.datetostr(d,'YYYY.MM.DD')
      return item
    })
    const makeItem = (item) => {
      return $(`
        <li class="shop-item">
          <a href="${item.href}" class="shop-item__link">
            <figure class="shop-item__img">
              <div class="shop-item__img-cover" style="background-image:url(${item.thumb})"><img src="${item.thumb}" alt="${item.title}" width="302" loading="lazy"></div>
              <span class="cat is-id${item.category.id}">${item.category.name}</span>
            </figure>
            <div class="shop-item__body">
              <span class="subject">${item.title.str_truncate(24)}${item.is_new ? '<span class="is-new">NEW</span>': ''}</span>
              <span class="desc">${item.desc.str_truncate(24)}</span>
            </div>
          </a>
        </li>`)
    }

    let pickupData = data.filter( v => v.keywords && v.keywords.includes('pickup') )

    let gymData = data.filter( v => v.category.id == 2 )
    let fitnessData = data.filter( v => v.category.id == 3 )

    $('.block-shop__pickup-list[data-plugin="getArticles"]').html( function() {
      $(this).empty()
      let amount = this.dataset.amount - 1
      $.each( pickupData.slice(0, amount ), (i, v) => $(this).append( makeItem(v) ) )
    })

    $('.block-shop__list[data-plugin="getArticles"][data-cat]').each(function(){
      let $this = $(this)
      let amount = this.dataset.amount
      $this.empty()
      let items = data.filter( v => v.category.id == this.dataset.cat )
      $this.html( function() {
        $.each( items.slice(0, amount ), (i, v) => $(this).append( makeItem(v) ) )
      })
    })
  })


  // news
  $.when(w.load['block-news']).then( () => {
    let makeItem = item => $(`
      <li class="news-item">
        <a href="${item.href}" class="news-item__link">
          <figure class="news-item__img">
            <div class="news-item__img-cover" style="background-image:url(${item.thumb})"><img src="${item.thumb}" alt="${item.title}" width="240" loading="lazy"></div>
          </figure>
          <div class="news-item__body">
            <span class="date">${item.date}</span>
            <span class="cate">［${item.category.name.str_truncate(8)}］</span>
            <span class="subject">${item.title.str_truncate(24)}</span>
          </div>
        </a>
      </li>
    `)[0]
    GET_ARTICLES('.block-news__list[data-plugin="getArticles"]', { makeItem })
  })
  
  $.when( w.load['loadHtml'] ).then( () => {
    ScrollTrigger.matchMedia({
      "(min-width: 900px)"() { parallax() }
    })
  })

}

export default function HOME() {
  init()
  $( documentReady )
}